import { actionWithDatapoint } from 'owa-analytics-actions';

import getEntryPoint from '../selectors/getEntryPoint';
import { getUserMailboxGuid } from '../utils/getMailboxGuid';

import type BookingService from 'owa-service/lib/contract/BookingService';

/**
 * Action to load the booking meetingTypes from the store.
 */

const loadMeetingTypes = actionWithDatapoint(
    'loadMeetingTypes',
    (meetingTypes: Map<string, BookingService>) => ({
        meetingTypes,
    }),
    actionMessage => ({
        customData: {
            meetingtTypeLength: actionMessage.meetingTypes.size,
            entryPoint: getEntryPoint(),
            mailboxGuid: getUserMailboxGuid(),
        },
    })
);

export default loadMeetingTypes;
